<template>
  <div class="sub_father">
    <div class="item_div">
      <img src="../../../static/img/服务6.png"/>
      <div class="item_tv">
        <p class="title">企事业单位保洁服务</p>
        <p class="content">宏邦拥有专业的保洁人员，素质高、能力强并拥有十年以上保洁经验。公司配备有专业的保洁设施、机器。所有从业人员均经过岗前培训、严格挑选、系统考核合格后方可从事家政服务的各项工作。为宁波及周边地区公共区域、办公楼、超市、商城、学校、宾馆、医院、展览馆等企业单位提供高品质家政式保洁服务。</p>
      </div>
    </div>
    
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
.sub_father{
  width:100%;
  margin-top:5rem;
}
.sub_father div:first-child{
  border-top :1px dashed var(--textBlack);
  border-bottom :1px dashed var(--textBlack);
}
.item_div{
  display :flex;
  padding: 4.8rem 2rem;
  // border-top :1px dashed var(--textBlack);
  border-bottom :1px dashed var(--textBlack);

  img{
    width:42.4rem;
    height:22.5rem;
    object-fit :contain;
  }
  .item_tv{
    align-content: center;
    justify-content: center;
    justify-items: center;
    flex-direction: column;
    display: flex;
    padding-left: 7.8rem;
  
  }

  .title{
    color:var(--textBlue);
    font-size:2.1rem;
    text-align :left;
  }
  .content{
    text-align :left;
    font-size:1.8rem;
    color:var(--textBlack);
    
  }
}
@media (max-width: 800px) {
  .item_div {
  flex-wrap:wrap;

    img{
      width:100%;
    }
    .item_tv{
      padding:0;
      margin-top:5rem;
    }
  }
}
</style>